import { installInteractionTimeTracking, installBNALib } from "@bonniernews-internal/bn-analytics-utilities";

import * as tracking from "./lib/tracking.js";
import * as didomi from "./lib/didomi.js";

window.trackingMpDebug = true;
window.bna ??= new EventTarget();
window.bna.debug = true;

installBNALib();
installInteractionTimeTracking();

const params = new URLSearchParams(window.location.search);
const utilVersion = params.get("utilityScriptVersionOverride");
if (utilVersion) {
  window.bnTrackingUtilitiesVersion = utilVersion;
}

(function (w, d, s, l, i) {
  w[l] = w[l] || []; w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
  const f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l !== "dataLayer" ? `&l=${l}` : "";
  j.async = true;
  j.src = `https://tracking.bna-test-site-lab.core.bn.nr/gtm.js?id=${i}${dl}`;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", "GTM-536WKFDN");

window.dataLayer = window.dataLayer || [];

didomi.mockDidomi();
didomi.pushDidomiConsent();
didomi.pushDidomiReady();

tracking.pushPageView();

document.querySelectorAll(".event-button").forEach((el) => {
  el.addEventListener("click", () => {
    const event = JSON.parse(el.getAttribute("data-event"));
    window.dataLayer.push(event);
  });
});

setInterval(() => {
  const versionNumber = (window.trackingDebugData && window.trackingDebugData.gtm && window.trackingDebugData.gtm.containerVersionNumber) ? window.trackingDebugData.gtm.containerVersionNumber : "unknown";
  document.title = `BN Analytics Test Site - v${versionNumber}`;
}, 100);
